import '.b6{position:relative;}.ssr-plugin'
import '.l{width:100%;}.ssr-plugin'
import '.h3{min-height:200px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.ap{justify-content:center;}.ssr-plugin'
import '.bv{align-items:flex-start;}.ssr-plugin'
import '.cr{padding:2rem;}.ssr-plugin'
import '.b8{background:var(--palette-white);}.ssr-plugin'
import '.ah{overflow:hidden;}.ssr-plugin'
import '.b9{position:absolute;}.ssr-plugin'
import '.is{top:50%;}.ssr-plugin'
import '.it{right:1rem;}.ssr-plugin'
import '.iu{transform:translateY(-50%);}.ssr-plugin'
import '.iv{width:120px;}.ssr-plugin'
import '.iw{height:120px;}.ssr-plugin'
import '.ix{z-index:0;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.i3{z-index:1;}.ssr-plugin'
import '.s{gap:0.5rem;}.ssr-plugin'
import '.iy{max-width:calc(100% - 140px);}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="b6 l h3 d e ap bv cr b8 ah"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="b9 is it iu iv iw ix d r ap"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="b6 i3 d e bv s iy"
      >
        {/* Bold Number */}
        <Title.H1
          style={{
            fontSize: '4rem',
            fontWeight: '700',
            lineHeight: '100%',
            margin: 0,
            color: 'var(--brand-secondary)',
            fontFamily: 'FunnelDisplay',
          }}
        >
          {number}
        </Title.H1>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--brand-secondary)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
